import { defineAsyncComponent, hydrateOnIdle, hydrateOnVisible } from 'vue';
import searchTitle from '@/msp/components/searchtitle/search-title.vue';

const searchError = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vmapsearch" */ '@/msp/components/searcherrorbox/search-errorbox.vue'),
    hydrate: hydrateOnIdle(),
});
import { mapActions, mapGetters, mapMutations } from 'vuex';
import mvtCardProperty from '@/common/components/mvtcardproperty/mvt-cardproperty.vue';
import { getStorage } from '../../../common/utilities/nojq/_localstorage.js';

function debounce(fn, wait) {
    let t;
    return function (...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
}

let _dppUtils = null;
function loadDppUtils() {
    if (!_dppUtils) {
        _dppUtils = Promise.all([
            import(/* webpackChunkName: "msp-dpp-utils" */ '@/common/store/mapper/index.js'),
            import(/* webpackChunkName: "msp-dpp-utils" */ '@/common/utilities/estprice.js'),
            import(/* webpackChunkName: "msp-dpp-utils" */ '@/common/utilities/mortgage.js'),
            import(/* webpackChunkName: "msp-dpp-utils" */ '@/common/utilities/sort.js'),
        ]).then(([m, e, mo, s]) => ({ mapper: m.default, estprice: e.default, mortgage: mo.default, sort: s.default }));
    }
    return _dppUtils;
}

let _ga4Utils = null;
function loadGa4Utils() {
    if (!_ga4Utils) {
        _ga4Utils = import(/* webpackChunkName: "msp-ga4" */ '../../../../widget/spec/ga4helper').then((m) => ({
            getSelectItem: m.getSelectItem,
            getItemMspPageData: m.getItemMspPageData,
        }));
    }
    return _ga4Utils;
}

const mvtAds = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vmapsearch" */ '@/common/components/mvtads/mvt-ads.vue'),
    hydrate: hydrateOnIdle(),
});

const searchAds = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vmapsearch" */ '@/msp/components/searchads/search-ads.vue'),
    hydrate: hydrateOnIdle(),
});

const searchAdsAgentConnection = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vmapsearch" */ '@/msp/components/searchads/search-adsagentconnection.vue'),
    hydrate: hydrateOnIdle(),
});

const mvtLazyload = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vmapsearch" */ '@/common/components/mvtlazyload/mvt-lazyload.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '200px' }),
});

const searchFooter = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vmapsearch" */ '@/msp/components/searchfooter/search-footer.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '200px' }),
});

export default {
    name: 'searchList',
    inject: ['$eventBus'],
    components: {
        searchError,
        searchFooter,
        searchAds,
        searchTitle,
        mvtAds,
        mvtCardProperty,
        mvtLazyload,
        searchAdsAgentConnection,
    },
    data() {
        return {
            buffer: 2,
            start: 0,
            end: 0,
            seeNearbyHomesRadiusIncrementor: 25,
            mvtAdsKey: 0,
            index: -1,
            currentDppDetail: null,
            isAreaSearchSaved: true,
            currentDppPhotoIndex: 0,
        };
    },
    mounted() {
        this.$el.addEventListener(
            'scroll',
            debounce(() => {
                if (this.$el.scrollTop > 50) {
                    document.getElementById('body').classList.add('searchlist-scrolled');
                } else {
                    document.getElementById('body').classList.remove('searchlist-scrolled');
                }
            }, 100)
        );
        this.$eventBus.$on('eventbus-expandsearch-nearby', (commuteRadius) => {
            this.searchNearBy(commuteRadius);
        });
        const agentReq = this.agentReq;
        (typeof requestIdleCallback !== 'undefined' ? requestIdleCallback : setTimeout)(() => {
            this.fetchAgents(agentReq);
        });
        this.isAreaSearchSaved = !!this.glb.user.id;
        this.$eventBus.$on('eventbus-map-property-selected', this.selectIndexByProperties);
    },
    beforeUnmount() {
        this.$eventBus.$off('eventbus-expandsearch-nearby');
        $(document).off('dom.scroll');
        $(this.$el).off('scroll');
    },
    watch: {
        agentReq(newValue) {
            this.fetchAgents(newValue);
        },
        isListView(newValue) {
            if (newValue) {
                this.selectIndex(0, true);
            } else {
                this.index = -1;
            }
        },
        getListings(newValue) {
            if (this.isListView) {
                if (newValue.length > 0) {
                    this.selectIndex(0, true);
                } else {
                    this.index = -1;
                }
            } else {
                this.index = -1;
            }
        },
        getDisplayPageIndex: function (newVal) {
            var data = this.getOriginalListings[newVal - 1];
            if (data && data.length) {
                var pageListing = data.map(function (e) {
                    return e.propertyId;
                });
                pageListing;
                this.updateCurrentPageListings(
                    data.map(function (e) {
                        return e.propertyId;
                    })
                );
            } else {
                this.updateCurrentPageListings([]);
            }
        },
    },
    methods: {
        ...mapMutations('msp', ['updateCurrentPageListings', 'updateDisplayIndex']),
        ...mapActions('msp', ['applyCoordinates', 'applyPagination', 'fetchPropertyByIds']),
        ...mapActions('glb', ['fetchBrokerageAgents', 'fetchCachedMortgageRates', 'updateFavorite', 'fetchNearbyHomesByLatLng', 'fetchDpp']),
        nextPhoto() {
            if (this.currentDppPhotoIndex < this.currentDpp.photoCount - 1) {
                this.currentDppPhotoIndex++;
            }
        },
        prevPhoto() {
            if (this.currentDppPhotoIndex > 0) {
                this.currentDppPhotoIndex--;
            }
        },
        openPhotoLink() {
            if (this.currentDpp && this.currentDpp.photoCount > 0) {
                window.open(this.currentDpp.dppUrl + '?popphoto=1', '_blank');
            }
        },
        toggleSort(key) {
            if (key === 'updated') {
                if (this.msp.filter.sort === 'sortby-updated-desc') {
                    this.$eventBus.$emit('eventbus-updatefilter', { sort: `sortby-dom-desc` });
                } else {
                    this.$eventBus.$emit('eventbus-updatefilter', { sort: `sortby-updated-desc` });
                }
                return;
            }

            if (this.msp.filter.sort === `sortby-${key}-asc`) {
                this.$eventBus.$emit('eventbus-updatefilter', { sort: `sortby-${key}-desc` });
            } else {
                this.$eventBus.$emit('eventbus-updatefilter', { sort: `sortby-${key}-asc` });
            }
        },
        selectIndexByProperties(propertyId, trigger) {
            if (propertyId && this.isListView) {
                let index = this.getListings.findIndex((property) => property.propertyId === propertyId);
                if (index > -1) {
                    this.selectIndex(index, trigger);
                }
            }
        },
        async selectIndex(index, trigger) {
            if (this.index === index && trigger !== true) {
                return;
            }
            this.currentDppDetail = null;
            this.index = index;
            if (this.getListings[index] && this.getListings[index].dppUrl) {
                let downPaymentRate = 25;
                let interestRate;
                let dppPreferences = getStorage('dppPreferences');
                if (dppPreferences && dppPreferences.paymentCalcValues) {
                    if (dppPreferences.paymentCalcValues.downpaymentRate) {
                        downPaymentRate = dppPreferences.paymentCalcValues.downpaymentRate;
                    }
                    if (dppPreferences.paymentCalcValues.interestRate) {
                        interestRate = dppPreferences.paymentCalcValues.interestRate;
                    }
                } else if (this.interestRate) {
                    interestRate = this.interestRate;
                } else {
                    let res = await this.fetchCachedMortgageRates();
                    if (res && res.data && res.data['FRM-30']) {
                        interestRate = res.data['FRM-30'];
                        this.interestRate = interestRate;
                    }
                }

                this.fetchDpp({ url: this.getListings[index].dppUrl }).then(async (res) => {
                    if (!res) {
                        return;
                    }
                    const { mapper, estprice, mortgage, sort } = await loadDppUtils();
                    let nearbyHomes = res.nearbyHomes
                        ? res.nearbyHomes.map((e) => {
                              return mapper.property(e, this.glb);
                          })
                        : [];
                    nearbyHomes = sort.sortProperty('similar_desc', nearbyHomes, this.currentDpp);
                    this.currentDppPhotoIndex = 0;
                    let photos = [];
                    if (res.categorizedPhotos && res.categorizedPhotos.length) {
                        photos = res.categorizedPhotos.reduce(function (prev, next) {
                            return prev.concat(
                                next.photos.map(function (image) {
                                    return image.url;
                                })
                            );
                        }, []);
                    }
                    this.currentDppDetail = {
                        permitAvm: res.permitAvm,
                        description: res.description,
                        photos: photos,
                        nearbySchoolAvgRating: res.nearbySchoolAvgRating,
                        monthlyInfo: mortgage.getMonthPayByTotal({ total: this.currentDpp.price, downpayment: downPaymentRate / 100, state: this.currentDpp.geo.state, interest: interestRate / 100 }),
                        estPriceInfo: estprice.getEstPriceForProperty(this.currentDpp, nearbyHomes.splice(0, 4)),
                    };
                });
                if (trigger !== 'property-marker') {
                    this.$eventBus.$emit('eventbus-map-property-selected', this.getListings[index].propertyId, 'searchlist');
                }
            }
        },
        loadPage(index) {
            if (!this.getIsSearching) {
                var that = this;
                this.applyPagination({
                    pageIndex: index,
                    paginationMode: 1,
                }).then((url) => {
                    url && that.$router.replace(url);
                });
            }
        },
        searchNearBy(commutePayload) {
            let geoRectData;
            const boundParams = (rect) => {
                return {
                    pointNE: rect.northeast,
                    pointSW: rect.southwest,
                    boundaryFilter: false,
                    newSearch: true,
                }
            }
            if (commutePayload?.radius) {
                const { lat, lng, radius } = commutePayload;
                const commuteLat = lat || this.geo.lat;
                const commuteLng = lng || this.geo.lng;

                if(commuteLat && commuteLng) {
                    geoRectData = this._getGeoRect(commuteLat, commuteLng, radius);
                }
            } else if(this.geo.lat && this.geo.lng){
                geoRectData = this._getGeoRect(this.geo.lat, this.geo.lng, this.seeNearbyHomesRadiusIncrementor * 1.6);
                this.seeNearbyHomesRadiusIncrementor *= 2;
            }

            if(geoRectData) {
                const params = boundParams(geoRectData);
                this.applyCoordinates(params).then((url) => {
                    url && this.$router.push(url);
                    this.$emit("searchNearBy");
                });
            }
        },
        _getGeoRect(lat, lng, radius) {
            const RADIUS_EARTH = 6371;
            const toRadians = function (n) {
                return (n * Math.PI) / 180;
            };
            const toDegrees = function (angle) {
                return angle * (180 / Math.PI);
            };
            if (isNaN(lat) || isNaN(lng) || isNaN(radius)) {
                return null;
            }
            const deltaLat = toDegrees(radius / RADIUS_EARTH);
            const deltaLng = toDegrees(radius / RADIUS_EARTH / Math.cos(toRadians(lat)));
            return {
                northeast: {
                    lat: parseFloat(lat) + deltaLat,
                    lng: parseFloat(lng) + deltaLng,
                },
                southwest: {
                    lat: parseFloat(lat) - deltaLat,
                    lng: parseFloat(lng) - deltaLng,
                },
            };
        },
        fetchAgents(params) {
            if (this.showAgents) {
                this.fetchBrokerageAgents(params);
            }
        },
        setAgentCard(agent) {
            if (agent) {
                agent.isAgentcard = true;
            }
            return agent;
        },
        favoriteAction(dpp) {
            let dppData = {
                formatMlsInfo: dpp.formatMlsInfo,
                geo: dpp.geo,
                mlsDescription: dpp.mlsDescription,
                mlsLogoSrc: dpp.mlsLogoSrc,
                photoCount: dpp.photoCount,
                tnImgPath: dpp.tnImgPath,
            };
            let options = {
                propertyData: dppData,
                propertyId: dpp.propertyId,
                listingId: dpp.listingId,
                isPrOnly: dpp.isPrOnly,
                isFavorite: !(this.favoriteListings.indexOf(dpp.propertyId) >= 0),
                trigger: this.$options.name,
                lite: true,
            };
            this.updateFavorite(options).then((res) => {
                if (res.status && res.status.code === 0 && options.isFavorite) {
                    this.$eventBus.$emit('dialog-center-tip', `<span class="text-bold">Success!</span> <span class="text-medium">Home saved.</span>`);
                }
            });
        },
        isInContainer(element) {
            //check if element is in current container
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        getViewedItems(cleanSViewed) {
            const propertyCards = this.$el.querySelectorAll('.mvt-cardproperty');
            if (cleanSViewed) {
                propertyCards.forEach((card) => {
                    delete card.dataset.viewed;
                });
            }
            const visibleCards = [];
            propertyCards.forEach((card) => {
                //let hasAttributeViewd = card.dataset('viewed');
                let hasAttributeViewd = card.dataset.viewed;
                if (!hasAttributeViewd && this.isInContainer(card)) {
                    card.dataset.viewed = true;
                    if (card.dataset.id) {
                        let item = this.getListings.find((item) => item.propertyId === card.dataset.id);
                        if (item) {
                            visibleCards.push(item);
                        }
                    }
                }
            });
            return visibleCards;
        },
        async sendSelectItem(propertyId) {
            let index = this.getListings.findIndex((item) => item.propertyId === propertyId);
            if (index >= 0) {
                const { getSelectItem, getItemMspPageData } = await loadGa4Utils();
                let { pageData, id, name } = getItemMspPageData(this.msp);
                let eventData = getSelectItem(id, name, this.getListings[index], index);
                this.$eventBus.$emit('ga4', { event: 'select_item' }, { eventData: eventData, pageData: pageData });
            }
        },
        /* Card Mouseover Events */
        onPropertyMouseEnter(propertyId) {
            if (this.msp.currentViewStatus === 'grid-view') {
                return;
            }
            this.$eventBus.$emit('eventbus-searchlist-property-hovered', propertyId, 'search-list');
        },
        onPropertyMouseLeave() {
            if (this.msp.currentViewStatus === 'grid-view') {
                return;
            }
            this.$eventBus.$emit('eventbus-searchlist-property-hovered', null, 'search-list');
        },
    },
    computed: {
        ...mapGetters('msp', [
            'geo',
            'msp',
            'getCurrentPageListings',
            'getListings',
            'getPaymentCalFilter',
            'getOriginalListings',
            'getTopListings',
            'getIsSearching',
            'getIsCommunitySearch',
            'getDisplayPageIndex',
        ]),
        ...mapGetters('glb', ['glb', 'viewport', 'getBrokerageAgents', 'getSplit', 'removeAds', 'favoriteListings']),
        isListView() {
            return this.msp.isListView;
        },
        getCardFilter() {
            let filterList = { propertyCriteriaOpenHouse: 'openHouse', updatePriceReduced: 'priceCut', propertyListedMovoto: 'listedByMovoto', updateNewConstruction: 'newConstruction' };
            for (var key in filterList) {
                if (this.msp.filter && this.msp.filter[key]) {
                    return filterList[key];
                }
            }
            return '';
        },
        isAdsBanner() {
            return !this.removeAds && this.getSplit('movoto-banner-ads-msp-cw-183');
        },
        getRestAds() {
            return !this.removeAds ? 4 - this.adsCount : 0;
        },
        isNoListings() {
            return this.getListings && this.getListings.length === 0;
        },
        sortByUpdated() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-updated-desc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-dom-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortByPrice() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-price-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-price-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortByDOM() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-dom-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-dom-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortByBed() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-beds-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-beds-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortByBath() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-baths-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-baths-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortByPricePerSqft() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-pricepersqft-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-pricepersqft-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortBySqft() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-sqft-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-sqft-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        sortByLot() {
            if (this.msp.filter && this.msp.filter.sort) {
                if (this.msp.filter.sort === 'sortby-lot-asc') {
                    return 'icon-arrow-up';
                } else if (this.msp.filter.sort === 'sortby-lot-desc') {
                    return 'icon-arrow-down';
                } else {
                    return '';
                }
            }
            return '';
        },
        isFavorite() {
            return this.favoriteListings.indexOf(this.currentDpp.propertyId) !== -1;
        },
        currentDpp() {
            if (this.index >= 0) {
                return this.getListings[this.index];
            }
            return null;
        },
        currentDppPhoto() {
            if (this.currentDppPhotoIndex > 0 && this.currentDppDetail && this.currentDppDetail.photos && this.currentDppDetail.photos.length) {
                return this.currentDppDetail.photos[this.currentDppPhotoIndex];
            } else {
                return this.currentDpp.tnImgPath;
            }
        },
        height() {
            return 260;
        },
        adsCount() {
            if (this.removeAds) {
                return 0;
            }
            let listings = this.getListings;
            if (listings.length <= 2) {
                return 0;
            } else if (listings.length < 6) {
                return 1;
            } else if (listings.length < 12) {
                return 2;
            } else if (listings.length < 18) {
                return 3;
            } else if (listings.length < 40) {
                return 4;
            } else if (listings.length < 50) {
                return 5;
            }
            return 6;
        },
        showAgents() {
            return !this.glb.rentals && !this.getIsCommunitySearch;
        },
        getRentalAdData() {
            return {
                title: 'Getting Ready To Move?',
                subTitle: 'Find local pros for help with packing and moving!',
                linkText: 'Get Quotes Now',
                href: `${this.glb.appUrl}homeservices/search/?query=movers${
                    this.glb.geo.zipcode ? `&zip_code=${this.glb.geo.zipcode}` : ''
                }&utm_medium=partnership&utm_source=cma-ojo-movoto&utm_campaign=rmsp`,
                type: 'moving',
                gaConf: { en: 'home_services_session', ec: 'partner', el: 'Thumbtack', props: { link_name: ' Get quotes now' } },
            };
        },
        getAgents() {
            if (!this.showAgents) {
                return null;
            }
            var agent = new Array(2);
            if (!this.glb.agent.id && this.getBrokerageAgents && this.getBrokerageAgents.length) {
                var index = Math.floor(Math.random() * this.getBrokerageAgents.length);
                if (this.getBrokerageAgents.length >= 2) {
                    if (index + 1 === this.getBrokerageAgents.length) {
                        agent[0] = this.getBrokerageAgents[index] || null;
                        agent[1] = this.getBrokerageAgents[0] || null;
                    } else {
                        agent[0] = this.getBrokerageAgents[index] || null;
                        agent[1] = this.getBrokerageAgents[index + 1] || null;
                    }
                } else {
                    agent[0] = this.getBrokerageAgents[index] || null;
                    agent[1] = null;
                }
                agent[0] = this.setAgentCard(agent[0]);
                agent[1] = this.setAgentCard(agent[1]);
            }
            agent.push(null, null, null);
            return agent;
        },
        agentReq() {
            return {
                zipcode: this.geo.zipcode || this.msp.firstZipcode,
                city: this.geo.city,
                state: this.geo.state,
                neighborhood: this.geo.neighborhood,
            };
        },
        getCityName() {
            return this.geo.city;
        },
    },
};
